import { useNavigate } from "react-router-dom"
import styles from './Card.module.scss'
const Card = ({ title, image, desc, link }) => {

  const navigate = useNavigate()

  return (
    <div className="bg-white p-2 d-grid gap-2 border border-secondary-subtle rounded cursor-pointer" onClick={() => navigate(link)}>
      <div className="text-center fw-semibold fs-5"><span>{title}</span></div>
      <div className="d-flex justify-content-center">
        <img src={image} alt="" width={325} height={217} className={styles.image} />
      </div>
      <div>{desc}</div>
    </div>
  )
}

export default Card